import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from "rxjs/operators";
import { AngularFirestore, DocumentData, QueryFn } from '@angular/fire/firestore';
import { DataService } from '../data.service';
import { InventoryItemDTO } from 'src/app/models/results/inventory-item-dto';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { constants } from 'src/environments/constants';
import { ILocaleInfo, UtilityService } from '../../utility.service';
import { TraferaInventoryItem } from 'src/app/models/data/trafera/trafera-inventory-item';

@Injectable({
  providedIn: 'root'
})
export class TraferaDataService implements DataService {

  constructor(
    private store: AngularFirestore,
    private auth: AngularFireAuth,
    private utilityService: UtilityService) { }

  updateResultConfigItem(item: ResultConfigViewModel): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  getAdminEmailAddresses(): Observable<string[]> {
    return of([]);
  }

  executeDatabaseQuery(): Observable<InventoryItemDTO[]> {
    const localeInfo: ILocaleInfo = this.utilityService.getLocaleInfo();

    const queryFn: QueryFn<DocumentData> = ref => ref.where('Locality', '==', localeInfo.localeName).where('Deleted', '==', false);

    return this.auth.user.pipe(
      take(1),
      switchMap(async user => {
        if (!user) {
          await this.auth.signInWithEmailAndPassword(environment.firebaseUserEmail, environment.firebase.apiKey);
        }
      }),
      switchMap(() => this.store.collection<TraferaInventoryItem>(`${constants.FIRESTORE_INVENTORY_COLLECTION}_trafera`, queryFn).valueChanges()),
      take(1),
      map((traferaItems: TraferaInventoryItem[]) => {
        return traferaItems.map(traferaItem => this.mapDTO(traferaItem));
      })
    );
  }

  mapDTO(traferaItem: TraferaInventoryItem): InventoryItemDTO {
    return Object.assign(new InventoryItemDTO(), {
      id: traferaItem.ID,
      hasBacklitKeyboard: traferaItem.BacklitKeyboard,
      hasFingerprintReader: traferaItem.HasFingerprintReader,
      hasPrivacyScreen: traferaItem.HasPrivacyScreen,
      hasStylus: traferaItem.HasStylus,
      cpuModel: traferaItem.CpuModel,
      diskDriveSize: traferaItem.DiskDriveSize,
      diskDriveUnit: traferaItem.DiskDriveUnit,
      diskDriveType: traferaItem.DiskDriveType,
      hasTouchscreen: traferaItem.HasTouchscreen,
      imageLargeLocation: traferaItem.ImageLarge,
      isEducation: traferaItem.IsEducation,
      isParallelsCapable: traferaItem.IsParallelsCapable,
      listPrice: TraferaInventoryItem.getPrice(traferaItem),
      locality: traferaItem.Locality,
      manufactureName: traferaItem.ManufactureName,
      manufacturePart: traferaItem.ManufacturePart,
      materialID: traferaItem.MaterialID,
      memorySize: traferaItem.MemorySize,
      memoryUnit: traferaItem.MemoryUnit,
      name: traferaItem.ProductDescShort.split(' - ')[0],
      productDescLong: traferaItem.ProductDescLong,
      productDescShort: traferaItem.ProductDescShort,
      productLine: traferaItem.ProductLine,
      productType: traferaItem.ProductType,
      formattedScreenSize: traferaItem.ScreenSize,
      screenSize: TraferaInventoryItem.getScreenSize(traferaItem),
      showInResults: traferaItem.ShowInResults,
      vendorURL: traferaItem.VendorURL
    });
  }
}
